<div class="row no-gutters justify-content-center">
  <div
    dropFiles
    (showFile)="showFile($event)"
    (overArea)="overField = $event"
    class="{{ colContainer }} border-attach mt-5 mb-5"
    [ngClass]="{ 'over-field': overField }"
  >
    <div class="row no-gutters mt-5 mb-3 justify-content-center">
      <img src="assets/images/uploadicon.svg" class="image-file" />
    </div>
    <div class="row no-gutters">
      <div class="col-md-12 d-flex justify-content-center">
        <div *ngIf="!showFileLoad && !hasError">
          Arrastre un archivo aquí
          <span *ngIf="required" class="text-danger ml-1">*</span>
        </div>
        <div *ngIf="showFileLoad && !hasError" class="file-info">
          <div *ngFor="let archivo of showFileLoad" class="d-flex align-items-center">
            <i class="fa fa-file mr-2 text-success"></i>
            <span class="text-success">{{ archivo.name }}</span>
            <span class="text-muted ml-2">({{ formatFileSize(archivo.size) }})</span>
            <button type="button" class="btn btn-sm btn-link text-danger ml-2" (click)="removeFile()">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
        <div *ngIf="hasError" class="text-danger">
          <i class="fa fa-exclamation-triangle mr-2"></i>
          {{ errorMessage }}
        </div>
      </div>
    </div>
    <div class="row no-gutters my-auto">
      <div class="col-md-12 d-flex justify-content-center mt-2 mb-2">
        <hr class="line-div" />
        <div>o</div>
        <hr class="line-div" />
      </div>
    </div>
    <div class="row no-gutters">
      <div
        class="col-md-12 justify-content-center mt-2 mb-5 d-flex align-items-center justify-content-center flex-column"
      >
        <button class="btn btn-file btn-chosse-file" [disabled]="showFileLoad && !hasError">
          BUSCAR ARCHIVO
          <input
            type="file"
            value="name"
            [accept]="formatString"
            (change)="showFile($event.target.files[0])"
            [disabled]="showFileLoad && !hasError"
          />
        </button>
        <small *ngIf="limiteMB && !hasError" class="text-danger mt-2 f-14">
          Tamaño máximo permitido: {{limiteMB}} MB
        </small>
        <small *ngIf="hasError" class="text-danger mt-2 f-14">
          {{ errorMessage }}
        </small>
      </div>
    </div>
  </div>
</div>
